<template>
  <div class="row">
    <div class="col-md-12">
      <h3 class="title">{{ $t('categories') }}</h3>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <p-button class="btn btn-primary pull-right" @click="handleCreateModal">
          <i class="fa fa-plus"></i> {{ $t('new_category') }}
        </p-button>
      </div>
      <div class="card-body row">
        <div class="col-md-6">
          <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              :placeholder="$t('search')"
              v-model="searchQuery"
              addon-right-icon="nc-icon nc-zoom-split"
            ></fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table v-loading="loading" :element-loading-text="$t('loading_data') + '...'" class="table-striped" :data="paginated" border style="width: 100%">
            <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" sortable></el-table-column>
            <el-table-column fixed="right" class-name="td-actions text-center" :label="$t('actions')">
              <template slot-scope="props">

                <p-button type="primary" size="sm" icon @click="handleEditModal(props.$index, props.row)">
                  <i class="fa fa-edit"></i>
                </p-button>

                <p-button v-if="props.row.isCoreCategory" type="danger" size="sm" icon :disabled="true" @click="handleDelete(props.$index, props.row)">
                  <i class="fa fa-times"></i>
                </p-button>

                <p-button v-else type="danger" size="sm" icon @click="handleDelete(props.$index, props.row)">
                  <i class="fa fa-times"></i>
                </p-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="card-footer">
        <paginate :pagination="pagination" :metadata="metaData" :allData="getAllCategories"></paginate>
      </div>

    </div>

    <!-- Edit Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{(!updateState) ? $t('new_category') : $t('edit_category')}}</h4>
      <ValidationObserver ref="categoryForm">
        <form>
          <ValidationProvider name="name" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.name" :placeholder="$t('name')" :label="$t('name')"></fg-input>
          </ValidationProvider>

          <span>
            {{ $t('is_core_category') }}
            <p-switch v-model="form.isCoreCategory" type="primary" on-text="Yes" off-text="No"></p-switch>
          </span>

          <span v-if="updateState">
             {{ $t('is_active') }}
            <p-switch v-model="form.isActive" type="primary" on-text="Yes" off-text="No"></p-switch>
          </span>

          <fg-input rules="required" v-if="!form.isCoreCategory">
            <el-select
              size="large"
              class="select-primary"
              filterable
              clearable
              v-model="form.parentID"
              :placeholder="$t('select_parent_category')"
            >
                <el-option
                  v-for="(item, c) in categories"
                  :key="c"
                  :label="item.name"
                  :value="item.id">
                </el-option>
            </el-select>
          </fg-input>
        </form>
      </ValidationObserver>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal">{{ $t('cancel') }}</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button v-if="!updateState" type="primary" link @click="createCategory">{{ $t('save') }}</p-button>
          <p-button v-if="updateState" type="primary" link @click="updateCategory">{{ $t('update') }}</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Modal from "src/components/UIComponents/Modal.vue";
import PSwitch from "src/components/UIComponents/Switch.vue";
import Paginate from '../../../UIComponents/Paginate.vue';

import Con from "@/util/helpers.js";
import Resource from "@/util/Api/resource.js";
const CategoryResource = new Resource("category");
const CategoryAllResource = new Resource("category/all");
const CatResource = new Resource("category/update");

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  components: {
    PPagination,
    Modal,
    PSwitch,
    Paginate
  },
  data() {
    return {
      modals: {
        classic: false
      },
      loading: false,
      updateState: false,
      pagination:{
          perPage: 10,
          perPageOptions: [10, 20, 30, 60, 500, 1000],
          currentPage:1,
          nextPage:'',
          prevPage:'',
          total:'',
          from:'',
          to:'',
          page:'',
      },
      searchQuery: "",
      tableColumns: [
        {
          prop: "name",
          label: this.$t("name"),
          minWidth: 200
        },
        {
          prop: "core",
          label: this.$t("core"),
        }
      ],
      metaData: {
         meta:'',
         links:''
      },
      tableData: [],
      categories: [],
      form: {
        name: "",
        isCoreCategory: false,
        parentID: "",
        isActive: false,
        categoryID: 0,
      },
      auth_user_id: localStorage.getItem("id")
    };
  },
  computed: {

    queriedData() {
        return Con.filterData(this.tableData, this.searchQuery);
    },

    paginated(){
        return Con.paginateData(this.queriedData, this.pagination);
    },
  },
  methods: {

    handleEditModal(index, row) {
      this.resetForm();
      this.updateState = true;
      this.form.categoryID = row.id;

      if(row.isCoreCategory === 1) {
        this.form.isCoreCategory = true;
      } else {
        this.form.isCoreCategory = false;
      }

      if(row.isActive === 1) {
        this.form.isActive = true;
      } else {
        this.form.isActive = false;
      }

      this.form.name = row.name;
      this.form.parentID = row.parentID;

      this.modals.classic = true;
    },

    resetForm() {
      this.form.name = "";
      this.form.isCoreCategory = false;
      this.form.parentID = "";
      this.form.isActive = false;
      this.form.categoryID = 0;
      this.$refs.categoryForm.reset();
    },

    handleCreateModal() {
      this.resetForm();
      this.updateState = false;
      this.modals.classic = true;
    },

    handleCloseModal() {
      this.modals.classic = false;
      this.updateState = false;
    },

    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },

    handleDelete(index, row) {
      this.$confirm(
        this.$t('confirm_delete') + ' ' + this.$t('category') + "?",
        this.$t('warning'),
        {
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
          cancelButtonClass: "btn-danger",
          confirmButtonClass: "btn-primary",
          type: "warning"
        }
      )
        .then(() => {
          let indexToDelete = this.tableData.findIndex(
            tableRow => tableRow.id === row.id
          );
          if (indexToDelete >= 0) {
            this.form = row;
            CategoryResource.destroy(this.form.id)
              .then(response => {
                this.tableData.splice(indexToDelete, 1);
                this.showAlertMessage(response.data.message, "success");
              }).catch(error => {});
          }
        })
        .catch(() => {});
    },

    async getCategories() {
       await CategoryResource.list({})
       .then(response => {
          this.categories = response.data;
          this.categories.forEach(element => {
            if(element.children) {
              this.categories = [...this.categories, ...element.children];
            }
          });
       }).catch(error => {
          console.log('error', error);
       });
    },

    async getAllCategories(page_url) {
      this.loading = true;
      if(page_url) {
         page_url = Con.splitStringLinks(page_url);
      }

      await CategoryAllResource.list(page_url)
      .then(response => {
          this.loading = false;
          if(this.tableData.length > 0){
            this.tableData = [...response.data.data, ...this.tableData];
          } else {
            this.tableData = response.data.data;
          }
          this.metaData.meta = response.data.meta;
          this.metaData.links = response.data.links;
        }).catch(error => {
          console.log('error', error);
          this.loading = false;
        });
    },

    async createCategory() {
      if(this.form.isCoreCategory == null) {
         this.form.isCoreCategory = false;
      }
      this.form.isActive = true;

      await CategoryResource.store(this.form)
        .then(response => {
           this.tableData = [response.data, ...this.tableData];
           this.handleCloseModal();
           this.showAlertMessage("Category created successfully", "success");
        })
        .catch(error => {
          this.showAlertMessage(error.response.data.message, "error");
          if (error.response.data.errors) {
            this.$refs.categoryForm.setErrors(error.response.data.errors);
          }
        });
    },

    async updateCategory() {
      await CatResource.update(this.form)
        .then(response => {
          const cat = this.tableData.findIndex(item => item.id === response.data.id);
          this.tableData.splice(cat, 1, response.data)
          this.handleCloseModal();
          this.showAlertMessage("Category updated", "success");
        })
        .catch(error => {
          this.showAlertMessage(error.response.data.message, "error");
          if (error.response.data.errors) {
            this.$refs.categoryForm.setErrors(
              error.response.data.errors.message
            );
          }
        });
    },

  },

  created() {
    this.getAllCategories();
    this.getCategories();
  }

};
</script>
<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
</style>
